import { z } from 'zod';

//CREATE
const _EquipmentFileCreateSchema = z.object({
  name: z.string().nullable().optional(),
  category: z.string().nullable().optional(),
});

export type EquipmentFileCreateDto = z.infer<typeof _EquipmentFileCreateSchema>;
